import { highlightSegments } from '../lib/highlight-segments';

/** Renders `text` with the searched words marked (FR-517). */
export function HighlightedText({ text, terms }: { text: string; terms: readonly string[] }) {
  // Segments are a positional split of one string, so the index is a stable key.
  return (
    <>
      {highlightSegments(text, terms).map((segment, index) =>
        segment.match ? (
          <mark key={index} className="rounded-sm bg-warning-bg px-px font-semibold text-foreground">
            {segment.text}
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </>
  );
}
